import { InjectionToken } from '@angular/core';
export const APP_CONFIG = new InjectionToken('APP_CONFIG');
/**
 * This map does a lookup for the directory name of the app deployed in the s3 bucket
 * We have certain exception like home and metadata-transformation where home does not have a directory and served from root
 * and metadata-transformation is served from umts package in s3.
 */
export const appDirLookupMap = {
    home: 'root',
    ['metadata-transformation']: 'umts'
};
//# sourceMappingURL=app-config.js.map